import { BindingError } from "../../BindingError.js";
const createBatchUpdatesOptions = (rootEnvironment, treeStore) => Object.freeze({
  getEntityByKey: (key) => {
    const realm = treeStore.entityRealmStore.get(key);
    if (realm === void 0) {
      throw new BindingError(`Trying to retrieve a non-existent entity: key '${key}' was not found.`);
    }
    return realm.getAccessor();
  },
  getEntityListSubTree: (aliasOrParameters, treeId, environment = rootEnvironment) => {
    return treeStore.getSubTreeState("entityList", treeId, aliasOrParameters, environment).getAccessor();
  },
  getEntitySubTree: (aliasOrParameters, treeId, environment = rootEnvironment) => {
    return treeStore.getSubTreeState("entity", treeId, aliasOrParameters, environment).getAccessor();
  }
});
export {
  createBatchUpdatesOptions
};
//# sourceMappingURL=createBatchUpdatesOptions.js.map
